import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, ImageIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export function LogoUpload({ logo, uploadUrl, onUploaded, disabled, label = "Unggah Logo", testId = "logo" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post(uploadUrl, fd);
      toast.success(`${label.replace("Unggah ", "")} berhasil diunggah`);
      onUploaded?.(data.logo ?? data.image);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <div className="flex items-center gap-4" data-testid={`${testId}-upload`}>
      <div className="h-20 w-20 border border-slate-300 rounded-sm bg-white flex items-center justify-center overflow-hidden">
        {logo ? <img src={logo} alt="" className="max-h-full max-w-full object-contain" data-testid={`${testId}-image`} /> : <ImageIcon className="h-6 w-6 text-slate-400" />}
      </div>
      {!disabled && (
        <div>
          <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testId}-file-input`} />
          <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => ref.current?.click()} data-testid={`${testId}-upload-btn`}>
            <Upload className="h-4 w-4 mr-2" />{busy ? "Mengunggah..." : label}
          </Button>
          <p className="text-[11px] text-slate-500 mt-1">PNG/JPG/WEBP/SVG, maks. 1 MB</p>
        </div>
      )}
    </div>
  );
}
